const useScrollIntoView = targetId => {
  return () => {
    const pageElement = document.getElementById(targetId);
    pageElement.scrollIntoView({ behavior: 'smooth' });
  };
};

export default useScrollIntoView;
